export const beeyProjectUrl = (projectId) => `/edit/${projectId}`;
